import React from "react";

export const PictureWall = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={92} height={30} rx={1} fill="#F1F2F6" />

    <g fill="#8E97A9">
      <rect width={11} height={11} x={1.5} y={3} />
      <rect width={11} height={11} x={14.5} y={3} />
      <rect width={11} height={11} x={27.5} y={3} />
      <rect width={11} height={11} x={40.5} y={3} />
      <rect width={11} height={11} x={53.5} y={3} />
      <rect width={11} height={11} x={66.5} y={3} />
      <rect width={11} height={11} x={79.5} y={3} />
      <rect width={11} height={11} x={1.5} y={16} />
      <rect width={11} height={11} x={14.5} y={16} />
      <rect width={11} height={11} x={27.5} y={16} />
      <rect width={11} height={11} x={40.5} y={16} />
      <rect width={11} height={11} x={53.5} y={16} />
      <rect width={11} height={11} x={66.5} y={16} />
      <rect width={11} height={11} x={79.5} y={16} />
    </g>
  </g>
);
